import { subscribe, emit, events } from './eventManager';

/**
 * This class is used to emit events for consumers using the component as a web component.
 * If the component is used internally within the universal components,
 * it can be consumed as a Preact component and does not require event emission.
 * Web components do not allow callbacks as props, therefore we need both options (callback and event emissions).
 *
 * @param {id} - An identifier used by the subscriber to tell if the result is for them
 * @param {count} - The count of related resources received
 *
 */
function resultsReceived(id, count) {
  let event = {
    resultCount: count
  };

  emit(events.RELATED_RESOURCES, event, id);
}

/**
 * This is a function to subscribe to the results received for related resources
 *
 * @param {function} callback - A callback function as a parameter.
 * @return {object} - An object consisting { id: number, value: number}
 *
 * @example
 *
 *     subscribeToRelatedResources(callback)
 */
function subscribeToRelatedResources(callback) {
  return subscribe(events.RELATED_RESOURCES, callback);
}

export default {
  resultsReceived,
  subscribeToRelatedResources
};
